// frontend/src/modules/agent-releases/api.ts
import { api } from '../../core/api-client';

export interface AgentRelease {
  version: string | null;
  macos_url: string | null;
  windows_url: string | null;
  notes: string | null;
  published_at: string | null;
  updated_at: string;
}

export type AgentReleaseInput = Partial<Pick<AgentRelease, 'version' | 'macos_url' | 'windows_url' | 'notes'>>;

export const agentReleasesApi = {
  // Super-admin
  get: () =>
    api<{ release: AgentRelease }>('/api/super-admin/agent-releases').then((r) => r.release),
  update: (input: AgentReleaseInput) =>
    api<{ release: AgentRelease }>('/api/super-admin/agent-releases', { method: 'PUT', body: input }).then((r) => r.release),

  // Tenant (read-only)
  getTenant: () =>
    api<{ release: AgentRelease }>('/api/monitoring/agent-releases').then((r) => r.release),
};
